let toastHandler = null;

function registerToastHandler(handler) {
  toastHandler = handler;
}

function showToast(message, severity = "success") {
  toastHandler?.(message, severity);
}

export { registerToastHandler, showToast };
